import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import getters from './getters'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    tagsView,
    permission,
    user
  },
  getters
})
